import React, { Fragment, useState } from 'react';
import styles from './styles.scss';

import {
  AppBar,
  AppBarContext,
  AppBarSection,
  AppBarTitle,
  Icons,
  Button,
  ButtonGroup,
  RadioButton,
} from '@densityco/ui';
import { Toaster } from '@densityco/ui';

import { SenseiApi } from './../../utils/api';
import { getRequiredSessionToken } from './../../utils/session-token';


import Popup from './../Popup';
import FormLabel from './../FormLabel';

import { ReannotateDataReason } from './../../types/reannotate-data-capture';

import {
  SensorsActionTypes,
} from './../../types/sensors';

import {
  Capture,
} from './../../types/api';

type SensorActionButtonsProps = {
  captureIds: Array<Capture["id"]>,
}

const SensorReannotateButton: React.FunctionComponent<SensorActionButtonsProps> = ({captureIds, }) => {

  const [popupOpen, setPopupOpen] = useState(false);
  const [ reannotateCaptureReason, setReannotateCaptureReason] = useState(ReannotateDataReason.DIFFERENT_LOCATION);

  return (
        <Fragment>
          <Popup
            target={
              <Button
                data-test-id="reannotate-button"
                rightIcon={<Icons.ChevronDown />}
              >
                Reannotate Captures
              </Button>
            }
            open={ popupOpen }
            onOpen={() => {
              setPopupOpen( true )

            }}
            onClose={() => {
                setPopupOpen( false )
              }
            }
            position={{ right: 0, top: 44 }}
            noPadding
          >
          <AppBarContext.Provider value="CARD_HEADER">
            <AppBar>
              <AppBarTitle>Reannotate Capture</AppBarTitle>
            </AppBar>
          </AppBarContext.Provider>
          <div className={styles.body}>


            <FormLabel
              label= {`Select the reason ${ captureIds.length } capture(s) needs to be reannotated?`}

              input={
                <Fragment>
                  <div
                    className={styles.choice}
                    data-test-id="reannotate-data-capture-reason"
                  >
                    <RadioButton
                      text="Moved to a Different Location"
                      checked={ reannotateCaptureReason == ReannotateDataReason.DIFFERENT_LOCATION }
                      onChange={() => setReannotateCaptureReason(ReannotateDataReason.DIFFERENT_LOCATION)
                      }
                    />
                  </div>
                  <div
                    className={styles.choice}
                    data-test-id="reannotate-data-capture-reason"
                  >
                    <RadioButton
                      text="Drastically moved triggerline"
                      checked={ reannotateCaptureReason == ReannotateDataReason.DIFFERENT_TRIGGER_LINE
                      }
                      onChange={() => setReannotateCaptureReason(ReannotateDataReason.DIFFERENT_TRIGGER_LINE)
                      }
                    />
                  </div>
                  <div
                    className={styles.choice}
                    data-test-id="reannotate-data-capture-reason"
                  >
                    <RadioButton
                      text="Put in MPI"
                      checked={ reannotateCaptureReason == ReannotateDataReason.PUT_IN_MPI }
                      onChange={() => setReannotateCaptureReason(ReannotateDataReason.PUT_IN_MPI)
                      }
                    />
                  </div>
                  <div
                    className={styles.choice}
                    data-test-id="reannotate-data-capture-reason"
                  >
                    <RadioButton
                      text="Changed from straight trigger line to parabolic"
                      checked={ reannotateCaptureReason == ReannotateDataReason.TRIGGER_LINE_CHANGE_STRAIGHT_PARABOLIC }
                      onChange={() => setReannotateCaptureReason(ReannotateDataReason.TRIGGER_LINE_CHANGE_STRAIGHT_PARABOLIC)
                      }
                    />
                  </div>

                  <div
                    className={styles.choice}
                    data-test-id="reannotate-data-capture-reason"
                  >
                    <RadioButton
                      text="Incorrectly Annotated"
                      checked={ reannotateCaptureReason == ReannotateDataReason.INCORRECTLY_ANNOTATED
                      }
                      onChange={() => setReannotateCaptureReason(ReannotateDataReason.INCORRECTLY_ANNOTATED)
                      }
                    />
                  </div>
                </Fragment>

                }
              />
          </div>
          <AppBarContext.Provider value="BOTTOM_ACTIONS">
            <AppBar>
              <AppBarSection />
              <AppBarSection>
                <ButtonGroup>
                  <Button
                    variant="underline"
                    onClick={() => { setPopupOpen( false )}
                    }
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="filled"
                    data-test-id="trigger-data-capture-submit"
                    onClick={() => {


                      const jwtToken = getRequiredSessionToken();

                      SenseiApi.sendCapturesForReannotation(
                        jwtToken,
                        captureIds,
                        reannotateCaptureReason,
                      )
                      .then(() => {
                        Toaster.showToast({
                          text: `Sent captures ${ captureIds.join(", ") } for reannotation.`,
                        });
                      })
                      .catch(() => {
                        Toaster.showToast({
                          text: `Error sending captures ${ captureIds.join(", ") } for reannotation!`,
                          type: 'error',
                        });
                      });

                      setPopupOpen( false );

                    }
                    }
                  >
                    Reannotate Capture
                  </Button>
                </ButtonGroup>
              </AppBarSection>
            </AppBar>
          </AppBarContext.Provider>
          </Popup>
        </Fragment>
  )
}

export default SensorReannotateButton;
